import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

// Importing icons for check indicators
import checkorange from '../../../../icons/check_orange.svg';
import checkwhite from '../../../../icons/check_white.svg';
import constants from "../../../../utils/constants";

export default function NavArtist({
  artPack, // Art pack data to determine menu availability
  isWalletConnected, // Boolean indicating if the user's wallet is connected
  menuState, // Data to check conditions for each menu item
  setMenuState
}) {
  const [disableMenu, setDisableMenu] = useState(false); // State to enable/disable menu items

  // Effect to manage menu availability based on artPack and menuState
  useEffect(() => {
    setDisableMenu(!artPack);
    if (!artPack) {
      setMenuState(null);
    }
  }, [artPack]);


  // Function to handle click event for disabled menu items
  const handleClick = (e) => {
    if (disableMenu) e.preventDefault(); // Prevent navigation if menu is disabled
  };

  return (
    <>
      {/* Artist Section */}
      <NavLink
        className="list-group-item list-group-item-action list-group-item-light padding-left-nav"
        end
        to={`/artist`}
      >
        {/* Displays checkmark if `menuState?.artist_check` is greater than 0 */}
        {({ isActive }) => (
          <>
            Artist
            {menuState?.artist_check > 0 && (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>

      {/* Art Pack Section */}
      <NavLink
        onClick={(e) => {
          if (!isWalletConnected) e.preventDefault(); // Prevent navigation if conditions aren't met
        }}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${!isWalletConnected ? "disable_nav" : "" // Apply disabled style if conditions aren't met
          }`}
        end
        to={`${constants.ARTIST_BASE_PATH}/art-pack`}
      >
        {({ isActive }) => (
          <>
            Art Pack
            {!disableMenu && (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>

      {/* Background Section with check icon */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : "" // Apply disabled style if menu is disabled
          }`}
        end
        to={`${constants.ARTIST_BASE_PATH}/background`}
      >
        {({ isActive }) => (
          <>
            Backgrounds
            {menuState?.background_check > 0 && ( // Display check icon if background_check is positive
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange} // Show active/inactive check icon
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>

      {/* Pattern Section with check icon */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.ARTIST_BASE_PATH}/pattern`}
      >
        {({ isActive }) => (
          <>
            Base Images
            {menuState?.pattern_check > 0 && ( // Display check icon if pattern_check is positive
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>

      {/* Layer Section with check icon */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.ARTIST_BASE_PATH}/layer`}
      >
        {({ isActive }) => (
          <>
            Layers
            {menuState?.layer_check > 0 && ( // Display check icon if layer_check is positive
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>

      {/* Layer Choice Section with check icon */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.ARTIST_BASE_PATH}/layerchoice`}
      >
        {({ isActive }) => (
          <>
            Choices
            {menuState?.layer_choice_check > 0 && ( // Display check icon if layer_choice_check is positive
              <img
                className={`menu-check-box extra-space-checkbox-3`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>

      {/* Approved Name Section with check icon */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.ARTIST_BASE_PATH}/approved-name`}
      >
        {({ isActive }) => (
          <>
            Approved Names
            {menuState?.approved_name_check > 0 && ( // Display check icon if approved_name_check is positive
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>

      {/* Pending Approval for Campaigns with check icon */}
      <NavLink
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav`}
        end
        to={`${constants.ARTIST_BASE_PATH}/approved-campaign`}
      >
        {({ isActive }) => (
          <>
            Pending approval
            {menuState?.pending_approval_check > 0 && ( // Display check icon if pending_approval_check is positive
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>
    </>
  );
}
